import { EvtHeader } from "components/header";
import CompanyForm from "@/modules/crm/companies/crud/form";
import React from "react";
import { useParams } from "react-router-dom";

const UpdateCompany = () => {
  const { companyId } = useParams();

  return (
    <div className="flex-1 max-w-md">
      <EvtHeader title="Update Company" />
      <div className="p-6 max-w-2xl">
        <CompanyForm companyId={companyId} />
      </div>
    </div>
  );
};

export default UpdateCompany;
